import { useAuth } from "react-oidc-context";
import { Button } from "@moodstudios/farmacenter-design";

/**
 * La invitación a entrar. No pide la contraseña —eso es de Keycloak—: sólo lleva
 * allí. Es lo único que ve alguien sin sesión.
 */
export function Entrar() {
  const auth = useAuth();

  return (
    <div className="grid min-h-screen place-items-center bg-surface-raised p-6">
      <div className="w-full max-w-sm rounded-panel border border-border bg-surface px-8 py-10 text-center shadow-sm">
        <p className="font-data text-xs font-semibold uppercase tracking-[0.16em] text-action">
          Farmacenter
        </p>
        <h1 className="mt-2 font-brand text-2xl font-bold tracking-tight text-text">
          Administración
        </h1>
        <p className="mt-3 text-sm text-text-muted">
          Inventario, compras, tesorería y contabilidad de las droguerías.
        </p>
        <Button
          variant="primary"
          className="mt-6 w-full"
          onClick={() => void auth.signinRedirect()}
        >
          Entrar
        </Button>
        <p className="mt-4 text-xs text-text-muted">
          Acceso con tu cuenta de Farmacenter. Se abre la página segura de inicio de sesión.
        </p>
      </div>
    </div>
  );
}
